import { gql } from '@apollo/client';

// Re-export the attach mutation so the initialize commit imports from one place.
// It already exists for the standalone attach/manage flow — don't duplicate it.
export { UPDATE_CLIENT_GROUP_PORTFOLIO } from '@ovComponents/4-module/widgets/portfolio/householdPortfolioMutations';

/**
 * Mints (or, idempotently, returns) the entity-bound clone of a shelf master
 * model portfolio for a household. Called at the end of the household model
 * portfolio Initialize workflow, before attaching the clone via
 * `updateClientGroupPortfolio`.
 *
 * We only need the clone `id` (to attach) and `warnings` (surfaced to the user).
 * The Initialize flow has no per-section editing, so we send no `customization`
 * (see `buildSetupEntityBoundModelInput`) and the clone inherits the base as-is.
 */
export const SETUP_ENTITY_BOUND_MODEL = gql`
  mutation setupEntityBoundModel($input: SetupEntityBoundModelInput!) {
    setupEntityBoundModel(input: $input) {
      modelPortfolio {
        id
      }
      warnings
    }
  }
`;
